
import { runStringOperations } from '../shonascript/Operations/stringOperations.js';
import { runButtonOperations } from './Operations/button.js';
import { runDivOperations } from './Operations/div.js';
import { runShonaScriptOperations } from './Operations/extractShonaScript.js';
import {runHeadingOperations } from './Operations/headings.js';
import { IconOperations, runIconOperations } from './Operations/icon.js';
import { runInputOperations } from './Operations/inputs.js';
import { runStyleOperations } from './Operations/styles.js';
import { runTextOperations } from './Operations/text.js';


export const dhagaJS = (lines) => {
    let errors = [];
    let shonascriptLines = []; // extract the shonaScript lines
    const classNames = [];
    // lines = lines.join('\n')
    let readLines  = lines.split('\n');
    readLines = readLines.map(x=> x.replace(/[\n\r]/g, ""));
    // ignore the empty strings
    let readLinesOriginal = readLines;
    // readLines = readLines.filter(x=> x.trim()!== "")
    // console.log(readLines)

    // readLines = runHeadingOperations(readLinesOriginal, readLines, errors);

    // first get the shonascript code from the dhaga file first

    let matcher = /[Pp]eji-c-/;
    if(matcher.test(readLines[0])){
        let color = readLines[0].replace(matcher, "");
        shonascriptLines.push(`document.getElementsByTagName('body')[0].style.backgroundColor = "${color}"`);
        readLines[0] = ""
    }else{
        shonascriptLines.push(`document.getElementsByTagName('body')[0].style.backgroundColor = "white"`);
    }

    readLines = runShonaScriptOperations(shonascriptLines, readLinesOriginal, readLines, errors).readLines;
    let output = runShonaScriptOperations(shonascriptLines, readLinesOriginal, readLines, errors).output;

    readLines = runDivOperations(readLinesOriginal, readLines, errors);
    
    readLines = runButtonOperations(readLinesOriginal, readLines, errors);

    // console.log(readLines)

    readLines = runTextOperations(readLinesOriginal, readLines, errors);
    // console.log(readLines);

    readLines = runHeadingOperations(readLinesOriginal, readLines, errors);

    readLines = runInputOperations(readLinesOriginal,readLines, errors);
    
    readLines = runIconOperations(readLinesOriginal, readLines, errors);

  
    runStyleOperations(readLinesOriginal, readLines,errors,   classNames)


    return {errors: errors, readLines: readLines, shonascriptLines: output}
}